import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Results" className="border-y border-white/[0.06] bg-charcoal" data-id="element-259" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8 sm:py-10" style={{
      paddingTop: "14px",
      paddingBottom: "13px"
    }} data-id="element-260" data-mp="2wvdwfz01y85d">
        <dl className="grid grid-cols-2 gap-y-6 sm:grid-cols-4 sm:divide-x sm:divide-white/[0.08]" data-id="element-261" data-mp="2nws79l02ruvm">
          {stats.map(s => <div key={s.label} className="flex flex-col-reverse text-center" data-id="element-262" data-mp="297vzlp1xkjvj">
              <dt className="mt-1 text-xs font-semibold uppercase tracking-[0.14em] text-steel" style={{
            fontSize: "10px"
          }} data-id="element-263" data-mp="2dym5r4i6kqra">{s.label}</dt>
              <dd className="font-display text-3xl font-extrabold text-ice sm:text-4xl" data-id="element-264" data-mp="2090uyhejbhuc">{s.value}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}